import { connect } from 'react-redux'
import ServiceEditPassengerType from '../../components/services/edit/ServiceEditPassengerType'
import ServiceEditPane from '../../components/services/edit/ServiceEditPane'
import { IStoreState, IRiderFilters, IServicePricingTypeObject, IServicePricingType } from '../../types/index'
import { getMany } from '../../state/actions/riders'
import { getRidersList } from '../../state/reducers/riders'
import { actions } from 'react-table'
import * as serviceActions from '../../state/actions/services'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    formRef: ownProps.formRef,
    onStepSuccessfullyCompleted: ownProps.onStepSuccessfullyCompleted,
    onCreateServiceCompleted: ownProps.onCreateServiceCompleted,
    handleSubmit: ownProps.handleSubmit,
    steps: state.serviceEdit.steps.list,
    routeProps: ownProps.routeProps,
    serviceId: ownProps.serviceId,
    pricingType: state.service.pricingType,
    fares: state.service.fares
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    //PricingType
    fetchServicePricingType: (serviceId: string) => dispatch(serviceActions.fetchServicePricingType(serviceId)),
    UpdateAllServicePricingType: (serviceId: string, dto: IServicePricingTypeObject) =>
      dispatch(serviceActions.UpdateAllServicePricingType(serviceId, dto))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceEditPassengerType)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceEditPassengerType.ts